import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/addnew',
    name: 'addnew',
    component: () => import('../views/AddItemView.vue')
  },
  {
    path: '/edit/:slug',
    name: 'edit',
    component: () => import('../views/EditView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
